const userToMember = (user, role) => {
  return {
    id: user.id,
    name: user.name || "",
    picture: user.pictureUrlCdn || null,
    role,
    createdAt: user.createdAt,
    modifiedAt: user.modifiedAt
  };
};

export { userToMember };
//# sourceMappingURL=userToMember.js.map
